export const logout=()=> {
    if (window.confirm("sicher?")) {
        localStorage.removeItem('user');
        localStorage.removeItem('round');
        localStorage.removeItem('char');
        window.location.reload();
    }
}